import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import SEO from './components/SEO';
import ErrorBoundary from './components/ErrorBoundary';
import { AnimationProvider } from './contexts/AnimationContext';
import { ScrollTop } from './components/ScrollTop';

// Lazy load components for code splitting
const Layout = lazy(() => import('./components/Layout'));
const Home = lazy(() => import('./components/Home'));
const About = lazy(() => import('./components/About'));
const Contact = lazy(() => import('./components/Contact'));
const EnterpriseAIPlatformDeployment = lazy(() => import('./components/EnterpriseAIPlatformDeployment'));

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-red"></div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <AnimationProvider>
        <ScrollTop/>
        <Routes>
      {/* Main site routes - promoted from demo */}
      <Route path="/" element={
        <Suspense fallback={<LoadingSpinner />}>
          <SEO 
            title="Tecbyte - AI Integration for Bangladesh's Future"
            description="Deploy advanced AI systems that respect your security requirements and regulatory compliance. Trusted by Bangladesh's critical organizations."
            canonical="https://tecbyte.io"
            schemaType="Organization"
            type="website"
          />
          <Layout>
            <Home />
          </Layout>
        </Suspense>
      } />
      
      <Route path="/about" element={
        <Suspense fallback={<LoadingSpinner />}>
          <SEO 
            title="About Tecbyte - AI Transformation Leaders"
            description="Learn how Tecbyte accelerates Bangladesh into the AI era with world-class expertise and local understanding."
            canonical="https://tecbyte.io/about"
            schemaType="WebPage"
            type="website"
          />
          <Layout>
            <About />
          </Layout>
        </Suspense>
      } />
      
      <Route path="/contact" element={
        <Suspense fallback={<LoadingSpinner />}>
          <SEO 
            title="Contact Tecbyte - Start Your AI Transformation"
            description="Ready to deploy AI that works for Bangladesh? Get started with secure AI integration tailored to your organization."
            canonical="https://tecbyte.io/contact"
            schemaType="WebPage"
            type="website"
          />
          <Layout>
            <Contact />
          </Layout>
        </Suspense>
      } />
      
      <Route path="/enterprise-ai-platform-deployment" element={
        <Suspense fallback={<LoadingSpinner />}>
          <Layout>
            <EnterpriseAIPlatformDeployment />
          </Layout>
        </Suspense>
      } />
      
      {/* Redirect demo routes to main site */}
      <Route path="/demo/*" element={<Navigate to="/" replace />} />
      <Route path="/demo" element={<Navigate to="/" replace />} />
        
      {/* Default route */}
      <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimationProvider>
    </ErrorBoundary>
  );
}

export default App; 